export const types = {
  receipt: 'Recebimento',
  reversal: 'Estorno',
  supply: 'Suprimento',
  withdrawal: 'Sangria',
  expense: 'Despesa',
};

export function getName(value) {
  return types[value] || value;
}

export const reviewStatuses = {
  pending: 'Aguardando conferência',
  ok: 'Conferido',
  flagged: 'Com ressalva',
};

export function getReviewStatusName(value) {
  return reviewStatuses[value] || value;
}

export function isReviewed(review) {
  return !!(review && review.user);
}

export function getReviewLabel(review) {
  const status = review ? review.status : 'pending';
  if (!isReviewed(review)) {
    return status === 'flagged' ? 'Diferença sinalizada' : 'Aguardando conferência';
  }
  return status === 'flagged' ? 'Com ressalva' : 'Sem ressalva';
}

export function getReviewClass(review) {
  const status = review ? review.status : 'pending';
  if (status === 'flagged') return 'label-error';
  return isReviewed(review) ? 'label-success' : 'label-warning';
}
